import React, { useEffect, useState, Fragment } from 'react';
import Traductor from "../Traductor";

function Pagination({ options, onPageChanged, isLoading }) {

    const t = new Traductor();
    const [currentPage, setCurrentPage] = useState();
    const [totalPages, setTotalPages] = useState();

    const [totalRecords, setTotalRecords] = useState();
    const [pageLimit, setPageLimit] = useState();
    // pageNeighbours can be: 0, 1 or 2
    const [pageNeighbours, setPageNeighbours] = useState();

    useEffect(() => {
        setCurrentPage(options.currentPage ? options.currentPage : 1);
        setTotalRecords(options.totalRecords ? options.totalRecords : 0);
        setTotalPages(Math.ceil(options.totalRecords / options.pageLimit));
        setPageLimit(options.pageLimit ? pageLimit : 10);
        setPageNeighbours(options.pageNeighbours ? Math.max(0, Math.min(options.pageNeighbours, 2)) : 0);
    }, [options]);

    const LEFT_PAGE = 'LEFT';
    const RIGHT_PAGE = 'RIGHT';

    /**
     * Helper method for creating a range of numbers
     * range(1, 5) => [1, 2, 3, 4, 5]
     */
    const range = (from, to, step = 1) => {
        let i = from;
        const range = [];

        while (i <= to) {
            range.push(i);
            i += step;
        }

        return range;
    }

    /**
   * Let's say we have 10 pages and we set pageNeighbours to 2
   * Given that the current page is 6
   * The pagination control will look like the following:
   *
   * (1) < {4 5} [6] {7 8} > (10)
   *
   * (x) => terminal pages: first and last page(always visible)
   * [x] => represents current page
   * {...x} => represents page neighbours
   */
    const fetchPageNumbers = () => {

        /**
         * totalNumbers: the total page numbers to show on the control
         * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
         */
        const totalNumbers = (pageNeighbours * 2) + 3;
        const totalBlocks = totalNumbers + 2;

        if (totalPages > totalBlocks) {

            const startPage = Math.max(2, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

            let pages = range(startPage, endPage);

            /**
             * hasLeftSpill: has hidden pages to the left
             * hasRightSpill: has hidden pages to the right
             * spillOffset: number of hidden pages either to the left or to the right
             */
            const hasLeftSpill = startPage > 2;
            const hasRightSpill = (totalPages - endPage) > 1;
            const spillOffset = totalNumbers - (pages.length + 1);

            switch (true) {
                // handle: (1) < {5 6} [7] {8 9} (10)
                case (hasLeftSpill && !hasRightSpill): {
                    const extraPages = range(startPage - spillOffset, startPage - 1);
                    pages = [LEFT_PAGE, ...extraPages, ...pages];
                    break;
                }

                // handle: (1) {2 3} [4] {5 6} > (10)
                case (!hasLeftSpill && hasRightSpill): {
                    const extraPages = range(endPage + 1, endPage + spillOffset);
                    pages = [...pages, ...extraPages, RIGHT_PAGE];
                    break;
                }

                // handle: (1) < {4 5} [6] {7 8} > (10)
                case (hasLeftSpill && hasRightSpill):
                default: {
                    pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
                    break;
                }
            }

            return [1, ...pages, totalPages];

        }

        return range(1, totalPages);

    }

    const gotoPage = page => {
        const currentPage = Math.max(0, Math.min(page, totalPages));
        const paginationData = {
            currentPage,
            totalPages: totalPages,
            pageLimit: pageLimit ? pageLimit : options.pageLimit,
            totalRecords: totalRecords
        };
        setCurrentPage(currentPage)
        onPageChanged(currentPage)
        //window.scrollTo(0, 0);
    }

    const handleClick = page => evt => {
        evt.preventDefault();
        gotoPage(page);
    }

    const handleMoveLeft = evt => {
        evt.preventDefault();
        let prevPage = currentPage - (pageNeighbours * 2) - 1;
        if (prevPage > 0) {
            gotoPage(prevPage);
        }
        //window.scrollTo(0, 0);
    }

    const handleMoveRight = evt => {
        evt.preventDefault();
        let nextPage = currentPage - (pageNeighbours * 2) + 1;
        if (nextPage <= totalPages) {
            gotoPage(nextPage);
        }
        //window.scrollTo(0, 0);
    }

    if (!totalRecords || totalPages === 1) return null;

    const pages = fetchPageNumbers();

    return (
        <Fragment>
            <nav className="c-pagination" aria-label="Pagination">
                <a href="#" className={"c-pagination__link  c-pagination__link--stepper-prev " + (currentPage <= 1 ? "is-disabled" : "")} onClick={handleMoveLeft} title="previous page">
                    <span>{t.getTraduction("Previous")}</span>
                </a>
                <ul className="c-pagination__list">
                    {pages.map((page, index) => {
                        if (page === LEFT_PAGE) return (
                            <li key={index} className="c-pagination__item">
                                <a className="c-pagination__link is-disabled" title="previous page">
                                    ...
                                </a>
                            </li>
                        );

                        if (page === RIGHT_PAGE) return (
                            <li key={index} className="c-pagination__item">
                                <a className="c-pagination__link is-disabled" title="next page">
                                    ...
                                </a>
                            </li>
                        );

                        return (
                            <li key={index} className={`c-pagination__item page-item${currentPage === page ? ' active' : ''}`}>
                                <a href="#" className={"c-pagination__link " + (currentPage === page ? ' is-active' : '')} onClick={handleClick(page)}>
                                    {page}
                                </a>
                            </li>
                        );
                    })}
                </ul>
                <a href="#" className={"c-pagination__link  c-pagination__link--stepper-next " + (currentPage >= totalPages ? "is-disabled" : "")} title="next page" onClick={handleMoveRight}>
                    <span>{t.getTraduction("Next")}</span>
                </a>
            </nav>
        </Fragment >
    )

}
/* 
Pagination.propTypes = {
    totalRecords: PropTypes.number.isRequired,
    pageLimit: PropTypes.number,
    pageNeighbours: PropTypes.number,
    onPageChanged: PropTypes.func
};
 */
export default Pagination;